import React from 'react';
import dryChickenImage from '../../images/product-photos/pack-shots/Dry-packshot-chicken.jpg';
import dryBeefImage from '../../images/product-photos/pack-shots/Dry-packshot-beef.jpg';
import {
  LOGGEDIN_LINKS,
  LOGO_URL,
  LOGO_SR_TEXT,
} from '../../molecules/Header/constants';
import { dryModalsContent } from '../../testing/modalConstants';
import { FOOTER_CONTENT } from '../../testing/constants';

export const content = {
  headline: 'Beef',
  fullIngredients:
    'Beef, beef heart, sweet potato, peas, potato, beef kidney, carrot, beef liver, spinach, chia seed, dicalcium phosphate, blueberries, fish oil, iodized salt, zinc gluconate, rosemary, vitamin E supplement, pyridoxine hydrochloride (vitamin B6), riboflavin (vitamin B2), potassium iodide',
  nutritionalInfo: [
    {
      label: 'Protein:',
      value: 'min 9%',
    },
    {
      label: 'Fat:',
      value: 'min 7%',
    },
    {
      label: 'Fiber:',
      value: 'max 2%',
    },
    {
      label: 'Moisture:',
      value: 'max 70%',
    },
  ],
  body: (
    <div>
      Hearty Beef Eats is formulated to meet the nutritional levels established
      by the AAFCO Dog Food Nutrient Profiles for All Life Stages, including
      growth of large size Dogs (>70 lbs or more as an adult). Calorie content
      (calculated): 1540 kcal ME/kg.
    </div>
  ),
  image: {
    src:
      'https://a.storyblok.com/f/89894/1280x1280/efd9790fcb/ollie_landingpage_product_beef-2.jpg',
    alt: 'beef',
    width: 420,
    height: 500,
  },
};

export const dryRecipes = [
  {
    title: 'Chicken',
    label: 'Add Chicken',
    value: 'chicken',
    benefit: 'Great for Sensitive stomachs',
    description:
      'With chicken as the first ingredient, plus chickpeas, eggs, and veggies, this recipe packs antioxidants, protein, and fiber into one hearty meal.',
    img: {
      src: dryChickenImage.src,
      alt: 'chicken recipe',
    },
    unavailableText:
      'Based on the allergies {{pupName}} has, this recipe is unavailable due to allergy concerns. Please contact our Canine Care team if you have any questions.',
  },
  {
    title: 'Beef',
    label: 'Add Beef',
    value: 'beef',
    benefit: 'Nutrient-rich recipe',
    description:
      'Hearty beef and sweet potatoes, plus nutrient-rich liver and oats, make for a well-rounded source of vitamins and minerals.',
    img: {
      src: dryBeefImage.src,
      alt: 'beef recipe',
    },
    unavailableText:
      'Based on the allergies {{pupName}} has, this recipe is unavailable due to allergy concerns. Please contact our Canine Care team if you have any questions.',
  },
];

export const petData = {
  pupName: 'Panda',
  pupCalories: 1000,
};

export const dryRecipesSelectionFormProps = {
  headline: "Choose {{pupName}}'s Baked meals",
  subtitle:
    'We recommend {{pupCalories}} calories of Baked food per day for {{pupName}}. Continue with up to two selections.',
  recipes: dryRecipes,
  defaultRecipes: [],
  unavailableRecipes: [],
  unavailableText:
    'Based on the allergies {{pupName}} has, this recipe is unavailable due to allergy concerns. Please contact our Canine Care team if you have any questions.',
  modals: dryModalsContent,
  onSubmit: () => {},
  submitButtonText: 'Next',
  cancelTarget: '/account',
  cancelButtonText: 'Cancel',
  footerContent: FOOTER_CONTENT,
  links: LOGGEDIN_LINKS,
  logoUrl: LOGO_URL,
  logoSrText: LOGO_SR_TEXT,
};
